import { useQuery } from '@tanstack/react-query';
import type { QueryKey } from '@tanstack/react-query';
import { fetchItem } from '../support/queries';
import type { Order } from '../types/taskManager';

export const isTerminalQueueOrder = (status?: string) =>
  status === 'completed' || status === 'failed' || status === 'partial';

/** Poll a queue order every five seconds until it reaches a terminal state. */
export const useQueueOrderStatus = (
  orderId: string | null | undefined,
  queryKey: QueryKey
) =>
  useQuery<Order>({
    queryKey,
    queryFn: () => fetchItem(`queue/orders/${orderId}`),
    ...{
      enabled: !!orderId,
      refetchInterval: (query) => {
        const data = query.state.data;
        return data && isTerminalQueueOrder(data.status) ? false : 5000;
      },
    },
  });
